import { FullScreenLoading } from '@/design-system/components/feedback/FullScreenLoading';

export function BaulesLoadingScreen() {
  return <FullScreenLoading message="Preparando tus baúles…" />;
}
